// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3xduI","label":"Completed_label__34iIo"};